module.exports = __webpack_public_path__ + "img/990rec.0b3788fe.png";